var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"calls-settings-section"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"active"},[_c('b',[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticClass:"calls-settings-section-body"},[_c('div',{staticClass:"col-sm-12"},[_vm._t("default")],2)]),_c('div',{staticClass:"clearfix"})])
}
var staticRenderFns = []

export { render, staticRenderFns }